import styled from "styled-components";
import { colors, spacingExtender } from "ui-components";

const CompletionDialogWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${colors.white}
`;

const CompletionDialogHeader = styled.div`
  width: 100%;
  color: ${colors.white};
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  background-color: ${colors.darkBlue};
  ${() => spacingExtender({ padding: 4 })};
`;

const CompletionDialogContent = styled.div`
  text-align: center;
  ${() => spacingExtender({ padding: 4 })};
`;

const CompletionDialogLinks = styled.div`
  display: flex;
  flex-direction: column;

  a:not(:last-of-type) {
    ${() => spacingExtender({ marginB: 1 })}
  }
`;

const CompletionDialogLink = styled.a`
  color: ${colors.maroon};
  font-weight: 500;
  text-decoration: underline;
`;

const CompletionDialogText = styled.div`
  color: ${colors.darkBlue};
  font-size: 20px;
  font-weight: bold;
  ${spacingExtender}
`;

const CompletionDialogButtons = styled.div`
  ${() => spacingExtender({ marginV: 5 })};

  button:not(:last-of-type) {
    margin-right: 1.5rem;
  }
`;

export {
  CompletionDialogWrapper,
  CompletionDialogHeader,
  CompletionDialogContent,
  CompletionDialogLinks,
  CompletionDialogLink,
  CompletionDialogText,
  CompletionDialogButtons
};



// WEBPACK FOOTER //
// ./src/common/components/CompletionDialog/styled.js